import React, { useRef, useState } from "react";
import { ALL_COLUMNS } from "./columns";
import useDismissOnOutside from "../../components/useDismissOnOutside";

export default function ColumnPicker({ visibleKeys, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useDismissOnOutside(ref, open, () => setOpen(false));

  const toggle = (key) => {
    const on = visibleKeys.includes(key);
    // Never let the table end up with zero columns.
    if (on && visibleKeys.length === 1) return;
    const next = on
      ? visibleKeys.filter((k) => k !== key)
      : [...visibleKeys, key];
    // Re-sort into canonical order so the table never depends on click order.
    onChange(ALL_COLUMNS.map((c) => c.key).filter((k) => next.includes(k)));
  };

  return (
    <span ref={ref} style={{ position: "relative", display: "inline-block" }}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="true"
        aria-expanded={open}
        className="border border-gray-300 rounded-md px-3 py-2 text-sm bg-white hover:bg-gray-50"
      >
        Columns ▾
      </button>
      {open && (
        <div className="absolute right-0 z-40 mt-1 bg-white border rounded-md shadow-lg py-1 max-h-80 overflow-y-auto min-w-[200px]">
          {ALL_COLUMNS.map((c) => (
            <label
              key={c.key}
              className="flex items-center gap-2 px-3 py-1.5 text-sm hover:bg-gray-50 cursor-pointer"
            >
              <input
                type="checkbox"
                checked={visibleKeys.includes(c.key)}
                onChange={() => toggle(c.key)}
              />
              <span>{c.label}</span>
            </label>
          ))}
        </div>
      )}
    </span>
  );
}
